/** @param {boolean} hasHeader @param {import('@mui/material').SxProps | undefined} paperSx */
export function floatingMenuPaperSx(hasHeader, paperSx) {
  return [
    {
      boxSizing: 'border-box',
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      width: hasHeader ? '240px' : 'fit-content',
      minWidth: hasHeader ? '240px' : 'var(--app-popup-min-width)',
      maxWidth: 'none',
      height: 'fit-content',
      minHeight: 'fit-content',
      padding: '6px',
      gap: '8px',
      backgroundColor: 'var(--app-bg-panel)',
      backgroundImage: 'none',
      border: '1px solid',
      borderColor: 'var(--app-border-light)',
      boxShadow: 'var(--app-elevated-shadow)',
      borderRadius: 'var(--app-radius-md)',
      cornerShape: 'var(--app-corner-shape)',
      WebkitCornerSmoothing: 'var(--app-squircle-ratio)',
      overflow: 'visible',
      marginLeft: '8px',
      color: 'var(--app-text-primary)',
    },
    ...(paperSx ? [paperSx] : []),
  ]
}
